import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Outlet } from 'react-router-dom';

export default function MainLayout() {
    return (
        <>
            <a href="#main-content" className="skip-to-content">Skip to main content</a>
            <Header />
            <main id="main-content">
                <Outlet /> {/* Child routes will render here */}
            </main>
            <Footer />
        </>
    );
}
